/* eslint-disable max-len */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {filter} from 'lodash';
import {Table, Loader, Button, Checkbox, Dropdown, Card, Label, Grid} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {pageSizes} from '../../../common/constants/lists';
import TablePaginator from '../../../common/components/tablePaginator';

class WarehouseLocationsTable extends Component {
  constructor(props) {
    super(props);

    this.handlePageClick = this.handlePageClick.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleItemCheckbox = this.handleItemCheckbox.bind(this);
    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handlePrintClick = this.handlePrintClick.bind(this);
    this.handleReleaseClick = this.handleReleaseClick.bind(this);
  }

  showErrorLocations(locationsWithStock) {
    const locations = locationsWithStock.map((item) => item.location);
    this.props.addMessageBoxError(
      `Petición no procesada, las ubicaciones: ${locations.join(
        ', '
      )} poseen stock`
    );
  }

  getPercentaje(part, total) {
    return ((parseInt(part || 0, 10) / parseInt(total || 0, 10)) * 100).toFixed(2);
  }

  handleItemCheckbox(event, data) {
    const {allocations} = this.props;
    this.props.updateSelectedLocations(allocations[data.value]);
  }

  handlePageClick(value) {
    this.props.changeWarehouseAllocationPage(value);
  }

  handlePageSizeChange(event, data) {
    this.props.changeWarehouseAllocationPage(0);
    this.props.changeWarehouseAllocationPageSize(data.value);
  }

  handleDeleteClick() {
    const {selectedLocations, warehouse} = this.props;
    const locationsWithStock = selectedLocations.filter((item) => item.stock);

    if (locationsWithStock.length) {
      this.showErrorLocations(locationsWithStock);
      return;
    }

    const locations = this.props.selectedLocations.map((item) => item.location);
    this.props.deleteWarehouseLocations(warehouse, locations);
  }

  handleSetAsAvailable(available) {
    const {selectedLocations, warehouse} = this.props;
    const locationsWithStock = selectedLocations.filter((item) => item.stock);

    if (available === 'N' && locationsWithStock.length) {
      this.showErrorLocations(locationsWithStock);
      return;
    }

    const locations = this.props.selectedLocations.map((item) => item.location);
    this.props.setAvailableWarehouseLocations(warehouse, locations, available);
  }

  handlePrintClick() {
    const locations = this.props.selectedLocations.map((item) => item.location);
    this.props.printWarehouseLocationsLabels(locations);
  }

  handleReleaseClick() {
    const {selectedLocations, warehouse} = this.props;
    const selectedMainLocations = filter(selectedLocations, {
      'type': 'PRINCIPAL',
    });
    const locationsWithStock = selectedMainLocations.filter(
      (item) => item.stock
    );

    if (locationsWithStock.length) {
      this.showErrorLocations(locationsWithStock);
      return;
    }

    const locations = this.props.selectedLocations.map((item) => item.location);
    this.props.releaseWarehouseLocations(warehouse, locations);
  }

  renderLocationsInfo(data) {
    const {selectedLocations} = this.props;

    return data.map((item, index) => {
      const isChecked =
        selectedLocations.findIndex(
          (element) => element.partCode === item.partCode && element.location === item.location
        ) > -1;

      return (
        <Table.Row key={index} textAlign='center'>
          <Table.Cell>{item.location}</Table.Cell>
          <Table.Cell>{item.pickingZone}</Table.Cell>
          <Table.Cell>{item.icc}</Table.Cell>
          <Table.Cell>{item.partCode}</Table.Cell>
          <Table.Cell>{item.partName}</Table.Cell>
          <Table.Cell>{item.stock}</Table.Cell>
          <Table.Cell>{item.available === 'S' ? 'Si' : 'No'}</Table.Cell>
          <Table.Cell>{item.type}</Table.Cell>
          <Table.Cell>
            <Checkbox
              onChange={this.handleItemCheckbox}
              value={index}
              checked={isChecked}
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderTableContent() {
    const {loading, allocations} = this.props;

    if (loading) {
      return (
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan={8}>
              <Loader inline='centered' active>
                Obteniendo información...
              </Loader>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      );
    }

    if (allocations.length > 0) {
      return <Table.Body>{this.renderLocationsInfo(allocations)}</Table.Body>;
    }

    return (
      <Table.Body>
        <Table.Row>
          <Table.Cell colSpan={8} textAlign='center'>
            No se pudo encontrar ningún registro
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    );
  }

  renderPagination() {
    const {pageNumber, pageSize, count} = this.props;

    if (count <= pageSize) {
      return null;
    }

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.handlePageSizeChange}
                />
              </span>
              <TablePaginator
                itemsCount={count}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.handlePageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    const {selectedLocations, deletingLocations, releasingLocations, settingAvailable, summary} =
      this.props;
    const areActionsDisabled =
      selectedLocations.length === 0 || deletingLocations || releasingLocations;

    if (deletingLocations || releasingLocations || settingAvailable) {
      return (
        <div>
          <Loader active>Procesando solicitud...</Loader>
        </div>
      );
    }

    return (
      <div className='locations-table'>
        <div className='actions'>
          <span className='selections'>
            <strong>Ubicaciones seleccionadas:</strong>{' '}
            {selectedLocations.length}
          </span>
          <Button
            primary
            disabled={areActionsDisabled}
            onClick={() => this.handleSetAsAvailable('S')}
          >
            Disponible
          </Button>
          <Button
            primary
            disabled={areActionsDisabled}
            onClick={() => this.handleSetAsAvailable('N')}
          >
            No Disponible
          </Button>
          <Button
            primary
            disabled={areActionsDisabled}
            onClick={this.handleDeleteClick}
          >
            Eliminar
          </Button>
          <Button
            primary
            disabled={areActionsDisabled}
            onClick={this.handlePrintClick}
          >
            Imprimir
          </Button>
          <Button
            primary
            disabled={areActionsDisabled}
            onClick={this.handleReleaseClick}
          >
            Liberar
          </Button>
        </div>
        <Card fluid raised>
          {summary &&
            <Grid columns={4} padded>
              <Grid.Row>
                <Grid.Column>
                  <Label color='blue' size='large'>
                  Total ubicaciones creadas: {summary?.total} ({this.getPercentaje(summary?.total, summary?.total)} %)
                  </Label>
                </Grid.Column>
                <Grid.Column>
                  <Label color='teal' size='large'>
                  Total ubicaciones con stock: {summary?.stock} ({this.getPercentaje(summary?.stock, summary?.total)} %)
                  </Label>
                </Grid.Column>
                <Grid.Column>
                  <Label color='blue' size='large'>
                  Total ubicaciones disponibles: {summary?.available} ({this.getPercentaje(summary?.available, summary?.total)} %)
                  </Label>
                </Grid.Column>
                <Grid.Column>
                  <Label color='teal' size='large'>
                  Total ubicaciones no diponibles: {summary?.notAvailable} ({this.getPercentaje(summary?.notAvailable, summary?.total)} %)
                  </Label>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          }
          <Table>
            <Table.Header>
              <Table.Row textAlign='center'>
                <Table.HeaderCell>Ubicación</Table.HeaderCell>
                <Table.HeaderCell>Zona</Table.HeaderCell>
                <Table.HeaderCell>ICC</Table.HeaderCell>
                <Table.HeaderCell>Código Item</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>Stock</Table.HeaderCell>
                <Table.HeaderCell>Disponible</Table.HeaderCell>
                <Table.HeaderCell>Tipo</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            {this.renderTableContent()}
            {this.renderPagination()}
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.warehouseAllocations.loading,
    'allocations': state.warehouseAllocations.list || [],
    'summary': state.warehouseAllocations.summary,
    'count': state.warehouseAllocations.count,
    'pageNumber': state.warehouseAllocations.offset,
    'pageSize': state.warehouseAllocations.limit,
    'selectedLocations': state.warehouseAllocations.selectedLocations,
    'deletingLocations': state.warehouseAllocations.deletingLocations,
    'releasingLocations': state.warehouseAllocations.releasingLocations,
    'settingAvailable': state.warehouseAllocations.settingAvailable,
  };
};

const {
  getWarehouseAllocations,
  changeWarehouseAllocationPage,
  changeWarehouseAllocationPageSize,
  updateSelectedLocations,
  deleteWarehouseLocations,
  releaseWarehouseLocations,
  printWarehouseLocationsLabels,
  addMessageBoxError,
  setAvailableWarehouseLocations,
} = Actions;

export default connect(mapStateToProps, {
  getWarehouseAllocations,
  changeWarehouseAllocationPage,
  changeWarehouseAllocationPageSize,
  updateSelectedLocations,
  deleteWarehouseLocations,
  releaseWarehouseLocations,
  printWarehouseLocationsLabels,
  addMessageBoxError,
  setAvailableWarehouseLocations,
})(WarehouseLocationsTable);
